module.exports = __webpack_public_path__ + "static/img/3.4a3c00a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/eng/3.png
// module id = IokR
// module chunks = 0